import "./Common/Footer.api";
export { FooterDesktop } from "./Desktop/FooterDesktop.container";
export { FooterMobile } from "./Mobile/FooterMobile.container";

export type FooterActions =
  | "gamename.set"
  | "gameproducer.set"
  | "clock.available.set"
  | "clock.date.set";
